module.exports = __webpack_public_path__ + "static/media/fhunknown.7b1e1ead.svg";